import { api, authApi, formData } from "utils";


export const getFAQList = (id) => () => {
	return api.get(`/products/faq?product_uniqid=${id}`)
		.then(res => {
			if (res.status === 200) {
				return res
			} else if(res.status === 401) {
				return res
			} else {
				throw res
			}
		}).catch(err => {
			throw err
		})
}

export const editFAQ = ({ question, answer, id, faq }) => () => {
	return authApi.post(`/products/faq/edit`, formData({
		product_uniqid: id,
		faq_uniqid: faq,
		answer: answer,
		question: question,
	}))
		.then(res => {
			if (res.status === 200) {
				return res
			} else if(res.status === 401) {
				return res
			} else {
				throw res
			}
		}).catch(err => {
			throw err
		})
}

export const createFAQ = ({ id, question, answer }) => () => {
	return authApi.post(`/products/faq/create`, formData({
		answer: answer,
		question: question,
		product_uniqid: id,
	}))
		.then(res => {
			if (res.status === 200) {
				return res
			} else if(res.status === 401) {
				return res
			} else {
				throw res
			}
		}).catch(err => {
			throw err
		})
}

export const deleteFAQ = ({ id, faq }) => () => {
	return authApi.post(`/products/faq/delete`, formData({
		faq_uniqid: faq,
		product_uniqid: id,
	}))
		.then(res => {
			if (res.status === 200) {
				return res
			} else if(res.status === 401) {
				return res
			} else {
				throw res
			}
		}).catch(err => {
			throw err
		})
}
